<template>
  <div class="home-skeleton">
    <UiSkeleton class="home-skeleton__banner" />
    <SkeletonWidgets class="home-skeleton__games" />
  </div>
</template>

<script>
import SkeletonWidgets from '~/components/shared/Skeletons/SkeletonWidgets'

export default {
  name: 'HomeSkeleton',
  components: {
    SkeletonWidgets,
  },
}
</script>
<style lang="scss" scoped>
.home-skeleton {
  & > * {
    margin-bottom: var(--spaces-2xl);

    @include media(tablet) {
      margin-bottom: var(--spaces-3xl);
    }
  }

  &__banner {
    height: 270px;
    border-radius: var(--radius-l);

    @include media(desktop) {
      height: 360px;
    }
  }
}
</style>
